import { usePetitionGuidesCategoryPageData } from '#src/app/pages/petitionGuides/category/details/pageContext';

type CtaSection = {
	title: string;
	ctaText: string;
	image: {
		alt: string;
		src: string;
	};
};

type Result = ModelHookResult<{
	ctaSection: CtaSection | null;
}>;

/**
 * `ctaSection` is null when the landing page content lookup itself came back null — the
 * article list is the point of this page, so a missing CTA just means rendering nothing here.
 */
export function useCTASection(): Result {
	const {
		data: { ctaSection },
	} = usePetitionGuidesCategoryPageData();

	if (!ctaSection) {
		return {
			data: {
				ctaSection: null,
			},
		};
	}

	const { heading, primaryActionText, image } = ctaSection;

	return {
		data: {
			ctaSection: {
				title: heading,
				ctaText: primaryActionText,
				image: {
					alt: image.title,
					src: image.url,
				},
			},
		},
	};
}
